/* eslint-disable react/no-children-prop */
import React from 'react';
import Select from 'react-select';
import { buildSelectStyles, selectComponentOverrides } from '../../../ui/select-styles';

export const SelectFilter = ({
  onChange,
  placeholder,
  options,
  setValue,
  isSearchable,
  isDisabled: isSelectDisabled,
  onInputChange,
  value,
  ...rest
}: any) => {
  return (
    <Select
      options={options}
      placeholder={placeholder}
      noOptionsMessage={() => 'Nenhum resultado encontrado'}
      onChange={(option: any) => {
        onChange(option?.value);
        if (setValue) {
          setValue(option?.value);
        }
      }}
      isClearable
      isDisabled={isSelectDisabled}
      isSearchable={isSearchable}
      onInputChange={onInputChange}
      value={options?.find((option: any) => option.value === value) ?? null}
      styles={buildSelectStyles({ size: 'sm', maxWidth: '350px' })}
      components={selectComponentOverrides}
      {...rest}
    />
  );
};
